import { Pagination as BSPagination } from "react-bootstrap";
import styles from "./Pagination.module.scss";

interface IPaginationProps {
    current: number;
    total: number;
    onPageClicked: (page: number) => void;
}

export const Pagination = (props: IPaginationProps) => {
    const { current, total, onPageClicked } = props;

    if (total <= 0) {
        return null;
    }

    const activePage = Math.min(Math.max(current, 1), total);

    const pageItems = Array
        .from(new Set([1, 2, activePage, total - 1, total]))
        .filter((n) => n >= 1 && n <= total)
        .sort((a, b) => a - b);

    const handlePageClick = (page: number) => {
        const nextPage = Math.min(Math.max(page, 1), total);
        if (nextPage !== activePage) {
            onPageClicked(nextPage);;
        }
    };

    return (
        <div className={styles.pagination}>
            <BSPagination>
                <BSPagination.First disabled={activePage === 1} onClick={() => handlePageClick(1)} />
                <BSPagination.Prev disabled={activePage === 1} onClick={() => handlePageClick(activePage - 1)} />
                {
                    pageItems
                        .flatMap((n, index) => {
                            const active = n === activePage;

                            const previous = pageItems[index - 1];
                            const hasGap = index > 0 && n - previous > 1;

                            const onClick = () => handlePageClick(n);

                            const gapElem = hasGap
                                ? <BSPagination.Ellipsis key={`ellipsis-${previous}-${n}`} disabled />
                                : null;

                            const itemElem = <BSPagination.Item active={active} onClick={onClick}>{n}</BSPagination.Item>

                            return [gapElem, itemElem];
                        })
                }
                <BSPagination.Next disabled={activePage === total} onClick={() => handlePageClick(activePage + 1)} />
                <BSPagination.Last disabled={activePage === total} onClick={() => handlePageClick(total)} />
            </BSPagination>
        </div>
    );
};